<div class="item-container">
    <div class="item-header">
      <h5 class="text-center">{{"Add Useful Document" | translate}}</h5>
      <div class="edit-icons" (click)="onCancel()">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="item-content main-c">
        <form action="" [formGroup]="usefulDoc" (ngSubmit)="onSave()">
        <div class="">
            <label for="" class="mt-3 mt-lg-4 pt-xl-3 req">Document Title</label>
            <input type="text" class="form-control " placeholder="Enter Title" formControlName="title">
            <div>
                <mat-error *ngIf="isControlHasError('title','required')">  {{"This is required"|translate}} </mat-error>
            </div>
            <label for="" class="mt-3 req  pt-lg-2">Select File</label>      
            <div class="drop-box m-auto  ">
                <ngx-dropzone (change)="onSelect($event)" class="drop-item" accept="application/pdf"  >
                    <ngx-dropzone-label >
                        <div class="d-flex flex-column align-items-center">
                            <div class="upload-img me-0">
                                <img src="assets/images/icons/upload.svg" class="img-fluid me-0">
                            </div>
                            <div>
                                <div>Click to Upload</div>
                                <div class="upload-text">Or just drag and drop</div>
                            </div>
                        </div>                
                    </ngx-dropzone-label>
                    <ngx-dropzone-preview *ngFor="let f of files"  (removed)="onRemove(f)"  [removable]="true">
                        <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                    </ngx-dropzone-preview>
                </ngx-dropzone>
            </div>     
            <mat-checkbox name="agree" class="mt-2 c-s" formControlName="all_user">
                <div class="text-wrap">Assign to all employee</div>
            </mat-checkbox>
            <div>
                <mat-error *ngIf="isControlHasError('all_user','required')">  {{"This is required"|translate}} </mat-error>
            </div>
             <div *ngIf="usefulDoc.value.all_user!=true">   
                <label for="" class="me-3 mt-2 pt-1">Select User Type</label>     
                <div class="d-flex flex-wrap">
                  <div class="e-b" [ngClass]="{'sel':userType=='department'}"(click)="onUserType('department')">Department</div>
                  <div class="e-b" [ngClass]="{'sel':userType=='manager'}" (click)="onUserType('manager')">Manager</div>
                  <div class="e-b" [ngClass]="{'sel':userType=='employee'}" (click)="onUserType('employee')">Employee</div>             
                </div>
                <label for="" class="me-3 mt-3 pt-lg-2">Select User </label>  
                <div *ngIf="userData" class="list">
                    <ng-multiselect-dropdown formControlName="department_id" *ngIf="userType=='department'" [settings]="dropdownSettings"[data]="userData.department_list"  >
                    </ng-multiselect-dropdown>
                    <ng-multiselect-dropdown formControlName="employee_id" *ngIf="userType=='employee'" [settings]="dropdownSettingsEmp" [data]="userData.employee"  >
                    </ng-multiselect-dropdown>
                    <ng-multiselect-dropdown formControlName="manager_id" *ngIf="userType=='manager'" [settings]="dropdownSettingsMan" [data]="userData.manager"  >
                    </ng-multiselect-dropdown>
                </div>            
             </div>    
        </div>
        
        </form>  
    </div>
    <div class="row item-footer">
        <div class="col-md-6 m-auto mt-xl-2">
          <button mat-raised-button   color="primary"  class="auth-form-btn mt-3 mt-lg-4"  type="submit" (click)="onSave()"
          [disabled]="files.length==0">{{ "Save" | translate }}</button>
        </div>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>